/*
  © 2025 KondaSoft
  https://www.kondasoft.com
*/

class AdvancedRichtext extends HTMLElement {
  constructor() {
    super();

    this.animateOnScroll()
  }

  animateOnScroll() {
    if (this.dataset.animateOnScroll === 'false') return

    const container = this.querySelector('.advanced-richtext-inner');
    const words = container.querySelectorAll('span');

    function updateWordVisibility() {
      const rect = container.getBoundingClientRect();
      const start = window.innerHeight * 0.1;
      const end = window.innerHeight * .4;
      const progress = Math.min(Math.max((window.innerHeight - rect.top - start) / (end - start), 0), 1);
      const wordCount = words.length;
      const visibleCount = Math.floor(progress * wordCount);

      words.forEach((word, index) => {
        if (index < visibleCount) {
          word.classList.add('visible');
        } else {
          word.classList.remove('visible');
        }
      });
    }

    document.addEventListener('scroll', updateWordVisibility, { passive: true });
    window.addEventListener('resize', updateWordVisibility);
    window.addEventListener('load', updateWordVisibility);
  }
}
customElements.define('advanced-richtext', AdvancedRichtext);